import { BaseWebComponent } from "./base-web-component.js";

export abstract class StepsComponent extends BaseWebComponent {

    constructor() {
        super();
        this.setupStepNavigation();

    }
    get readOnly(): boolean {
        return this.hasAttribute('readonly') ||  this.closest('[readonly]') !== null ;
    }
    protected _step: string = '';
    public get step(): string {
        return this._step;
    }
    protected set step(value: string) {
        this._step = value;
        this.stepsRefresh();
    }

    private setupStepNavigation() {
        this.on('click', '[data-go-step]', (event: Event) => {
            event.preventDefault();
            const target = event.target as HTMLElement;
            const stepName = target.dataset.goStep;
            if (stepName) {
                this.goToStep(stepName, target);
            }
        });
    }

    /**
     * Passa allo step richiesto inviando gli eventi di lifecycle.
     * Ritorna true se il cambio è avvenuto, false se annullato o lo step non esiste.
     */
    public goToStep(step: string, target?: HTMLElement, dispatchEvent = true): boolean {
        if (!this.stepExists(step) || this.readOnly) {
            return false;
        }
        if (dispatchEvent) {
            const ev = this.dispatch('before-step-changed', {
                step,
                target
            });
            if (ev.defaultPrevented) {
                return false;
            }
        }

        this.step = step;
        if (dispatchEvent) {
            this.dispatch('step-changed', { step, target });
        }
        return true;
    }
    protected afterRender(): void {
        this.stepsRefresh();
    }
    /**
     * Ottiene solo gli step che appartengono direttamente a questo componente
     * Evita conflitti con step-components annidati
     */
    protected get componentSteps(): Element[] {
        const steps = this.querySelectorAll('.step');
        // convert NodeList to Array and filter only direct children steps
        return Array.from(steps).filter((stepElement: Element) => {
            return stepElement.parentElement === this;
        });
    }

    /**
     * Verifica se esiste uno step con il role specificato
     * @param role - Il valore dell'attributo role da cercare
     */
    protected stepExists(role: string): boolean {
        return this.componentSteps.some(stepElement =>
            stepElement.getAttribute('role') === role
        );
    }

    protected stepsRefresh(): void {
        this.componentSteps.forEach((stepElement: Element) => {
            if (stepElement instanceof HTMLElement) {
                stepElement.classList.add('d-none');
                if (stepElement.getAttribute('role') === this.step) {
                    stepElement.classList.remove('d-none');
                }
            }
        });
    }
}